var webpackThen = typeof Symbol === "function" ? Symbol("webpack then") : "__webpack_then__";
var webpackExports = typeof Symbol === "function" ? Symbol("webpack exports") : "__webpack_exports__";
var webpackError = typeof Symbol === "function" ? Symbol("webpack error") : "__webpack_error__";
var completeQueue = (queue) => {
	if(queue) {
		queue.forEach((fn) => (fn.r--));
		queue.forEach((fn) => (fn.r-- ? fn.r++ : fn()));
	}
}
var completeFunction = (fn) => (!--fn.r && fn());
var queueFunction = (queue, fn) => (queue ? queue.push(fn) : completeFunction(fn));
var wrapDeps = (deps) => (deps.map((dep) => {
	if(dep !== null && typeof dep === "object") {
		if(dep[webpackThen]) return dep;
		if(dep.then) {
			var queue = [];
			dep.then((r) => {
				obj[webpackExports] = r;
				completeQueue(queue);
				queue = 0;
			}, (e) => {
				obj[webpackError] = e;
				completeQueue(queue);
				queue = 0;
			});
			var obj = {};
			obj[webpackThen] = (fn, reject) => (queueFunction(queue, fn), dep['catch'](reject));
			return obj;
		}
	}
	var ret = {};
	ret[webpackThen] = (fn) => (completeFunction(fn));
	ret[webpackExports] = dep;
	return ret;
}));
__webpack_require__.a = (module, body, hasAwait) => {
	var queue = hasAwait && [];
	var exports = module.exports;
	var currentDeps;
	var outerResolve;
	var reject;
	var isEvaluating = true;
	var nested = false;
	var whenAll = (deps, onResolve, onReject) => {
		if (nested) return;
		nested = true;
		onResolve.r += deps.length;
		deps.map((dep, i) => (dep[webpackThen](onResolve, onReject)));
		nested = false;
	};
	var promise = new Promise((resolve, rej) => {
		reject = rej;
		outerResolve = () => (resolve(exports), completeQueue(queue), queue = 0);
	});
	promise[webpackExports] = exports;
	promise[webpackThen] = (fn, rejectFn) => {
		if (isEvaluating) { return completeFunction(fn); }
		if (currentDeps) whenAll(currentDeps, fn, rejectFn);
		queueFunction(queue, fn);
		promise['catch'](rejectFn);
	};
	module.exports = promise;
	body((deps) => {
		currentDeps = wrapDeps(deps);
		var fn;
		var getResult = () => (currentDeps.map((d) => {
			if(d[webpackError]) throw d[webpackError];
			return d[webpackExports];
		}))
		var promise = new Promise((resolve, reject) => {
			fn = () => (resolve(getResult));
			fn.r = 0;
			whenAll(currentDeps, fn, reject);
		});
		return fn.r ? promise : getResult();
	}, (err) => (err && reject(promise[webpackError] = err), outerResolve()));
	isEvaluating = false;
};